import React from 'react';
import { useTranslation } from 'react-i18next';

const Footer = () => {
    const { t } = useTranslation();
    const currentYear = new Date().getFullYear();

    return (
        <footer className="bg-white dark:bg-slate-800 border-t border-gray-200 dark:border-slate-700 mt-8 sm:mt-16">
            <div className="container mx-auto px-3 sm:px-4 py-6 sm:py-8">
                <div className="flex flex-col md:flex-row justify-between items-center space-y-3 md:space-y-0">
                    {/* Copyright */}
                    <div className="text-center md:text-left">
                        <p className="text-gray-600 dark:text-gray-400 text-xs sm:text-sm">
                            © {currentYear} {t('Vazduhoplovni savez Srbije | Meteo')}. {t('All rights reserved')}.
                        </p>
                    </div>

                    {/* Developer Credit */}
                    <div className="text-center md:text-right">
                        <p className="text-gray-500 dark:text-gray-500 text-xs sm:text-sm">
                            {t('Developed by')} <span className="font-medium text-gray-700 dark:text-gray-300">Milan Palangetic</span> @ <span className="font-medium text-blue-600 dark:text-blue-400">DevLance</span>
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;